import { CAT, LANG_V2_CAT, MAS, SUB  } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { CAT_FORM_SCHEMA, getCategoryMongooseSchema } from "./utils";


/*
{
  _id
  _mastercategory: LanguageData
  _lang_v2: parent id
  type: 'mastercategories'

}
*/
export class Category extends LanguageCategory{
  constructor(data){
    super(data)
    // this.changed = false
    this.type = Category.getTypeDir()
    this.childTypes = Category.getChildTypes()
  }

  toOldLangEntry(){
    let {fullNumber, number, content, _name} = this
    return {
      [`!fullNum`]: fullNumber,
      [`!num`]: number,
      _mask:content,
      _name
    }
  }

  getDisplayText(){
    return `${this.fullNumber} ${this.content}`
  }

  getFormData(){
    return LanguageCategory.getFormData(Category, this)
  }

  static getFormKeys(){
    return ['number', 'fullNumber', 'content']
  }

  static getFormSchema(){
    return CAT_FORM_SCHEMA
  }

  static getTypeDir(){
    return CAT
  }
  
  static getRelType(){
    return LANG_V2_CAT
  }

  static getParentKey(){
  return MAS
  }

  static getParentAddress(){
    return super.getParentAddress(Category)
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(Category)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(Category)
  }

  static constructFromDBData(data){
    return new Category(super.constructFromDBData(data, Category.getTypeDir()))
    
  }
  static getFormColWidths(){
    return {
      number:4,
      fullNumber:4,
      content:4
    }
  }

  static getMongooseSchema(mongoose, Schema ){
    return super.getMongooseSchema(
      mongoose, 
      Schema, 
      getCategoryMongooseSchema(mongoose, Category),
      Category.getTypeDir()
    )
  }

  static getChildTypes(){
    return [SUB]
  }
}